import { Close } from "@mui/icons-material";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import LifecycleTable from "components/summary/index/ExpandPlanRevamp/LifecycleTable";
import { SuccessPlanState } from "components/summary/success-plan/state/successPlan.types";
import styles from "./SuccessPlan.module.scss";

type LifecycleAdoptionDialogProps = {
  open: boolean;
  onClose: () => void;
  spState: SuccessPlanState;
};

const LifecycleAdoptionDialog = ({ open, onClose, spState }: LifecycleAdoptionDialogProps) => {
  const { spData } = spState;

  return (
    <Dialog
      open={open}
      maxWidth="xl"
      fullWidth
      onClose={onClose}
    >
      <DialogTitle>
        <div className={styles["title-box"]}>
          <span className={styles["title-box__title"]}>Lifecycle Adoption Engagement</span>
          <IconButton
            size="small"
            onClick={onClose}
          >
            <Close />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <LifecycleTable
          data={spData}
          idTag={"lifecycleData"}
        />
      </DialogContent>
    </Dialog>
  );
};

export default LifecycleAdoptionDialog;
